import { render, staticRenderFns } from "./ServicesGroup.vue?vue&type=template&id=4deb4895"
import script from "./ServicesGroup.vue?vue&type=script&lang=js"
export * from "./ServicesGroup.vue?vue&type=script&lang=js"
import style0 from "./ServicesGroup.vue?vue&type=style&index=0&id=4deb4895&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports